import React, {useEffect, useState} from "react";
import {BrowserRouter, Route} from 'react-router-dom';
import {useRoutes} from './routes';
import {QueryParamProvider} from 'use-query-params';
import {apiGetConfigs} from "../api/apiCommands";
import TechnicalMode from "./TechnicalMode";

function App() {
    const routes = useRoutes();
    const [technicalMode, setTechnicalMode] = useState(false)
    const [technicalModeMessage, setTechnicalModeMessage] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const response = apiGetConfigs()
            .then((response) => {
                const {technicalMode} = response;
                setTechnicalMode(technicalMode.enabled);
                setTechnicalModeMessage(technicalMode.message);
            })
            .catch((error) => {
            })
            .finally(_ => {
                setIsLoading(false)
            })
        ;
    }, []);

    return (
        <BrowserRouter>
            {!isLoading && <QueryParamProvider ReactRouterRoute={Route}>
                { technicalMode ? <TechnicalMode message={technicalModeMessage} /> : routes}
            </QueryParamProvider>
            }
        </BrowserRouter>
    );
}

export default App;
